import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import { NavLink } from "react-router-dom";

//Components
import ChipStatus from 'Components/ChipStatus';
import DataView from 'Components/DataView';

//Actions
import { devicesByStatusRequest, clearRedux, genericExportSend } from 'Redux/actions';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Styles
import './index.scss'
const DevicesByStatus = (props) => {
    const { item, update, exportData } = props
    let idgadget = `${item.type}-${item.id}`

    const dispatch = useDispatch();
    const { messages } = useIntl();

    const gadgetInformation = useSelector(state => state.devicesByStatusRedux)

    const [columns, setColumns] = useState([
        {
            key: "accountName",
            width: 200,
            title: messages['device_status_account'],
            show: true,
            export: true,
            exportCell: "accountName",
            functionString: "return row?.accountName",
            code: "device_status_account",
            render: (item) => {
                return (
                    <NavLink to={`/app/accounts/overview/${item?.accountId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.accountName}</span>
                    </NavLink>
                )
            }
        },
        {
            key: "deviceId",
            width: 150,
            title: messages['device_status_serial'],
            show: true,
            export: true,
            exportCell: "accountName",
            functionString: "return row?.esn",
            code: "device_status_serial",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item.deviceId}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item.esn}</span>
                    </NavLink>
                )

            }
        },
        {
            key: "status",
            width: 150,
            title: messages['device_status_status'],
            show: true,
            export: true,
            code: "device_status_status",
            functionString: 'return `${row?.status === 1 ? "Active" : row?.status === 2 ?  "Voluntary Suspension" : row?.status === 3 ?  "Involuntary Suspension" : row?.status === 4 ?  "Cancelled" : row?.status === 6 ?  "RMA" : "Desactivated" }`;',
            render: (item) => {
                return <ChipStatus showTooltip statusCode={item.status} messages={messages} />
            }
        },
        {
            key: "manufacturerName",
            width: 150,
            title: messages['device_status_manufacturer'],
            show: true,
            export: true,
            functionString: "return row?.manufacturerName",
            code: "device_status_manufacturer",
            render: (item) => {
                return <span>{item.manufacturerName}</span>
            }
        },
        {
            key: "eventName",
            width: 150,
            title: messages['device_status_event'],
            show: true,
            export: true,
            functionString: "return row?.eventName",
            code: "device_status_event",
            render: (item) => {
                return <span>{item.eventName}</span>
            }
        },
        {
            key: "age",
            width: 110,
            title: messages['device_status_age'],
            show: true,
            export: true,
            functionString: "return row?.age",
            code: "device_status_age",
            render: (item) => {
                return <span>{item.age}</span>
            }
        },
        {
            key: "lastMessageTime",
            width: 250,
            title: messages['device_status_last_readings'],
            show: true,
            functionString: `
                function formatDateWithTimezone(date, tz) {
                    let dateToformat = moment(date)
                    let formatted = moment(dateToformat).tz(tz).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }
                return row?.lastMessageTime ? formatDateWithTimezone(row.lastMessageTime, row.timezone) : ''
            `,
            code: "device_status_last_readings",
            render: (item) => {
                return <span>{getDateFormatted(item.lastMessageTime, "date", "datetime", null, item?.timezone)}</span>
            }
        }
    ])

    const devicesByStatusDashboard = (values) => {
        dispatch(devicesByStatusRequest({
            age: values?.age,
            dealerId: values?.dealerId,
            unitStatus: values?.unitStatus,
            accountId: values?.accountId,
            manufacturerId: values?.manufacturerId,
            deviceModelId: values?.deviceModelId,
            gadget: idgadget,
            offset: values?.offset,
            clear: values?.clear,
            tagIds: values?.tagIds || []
        }))
    }

    useEffect(() => {
        if (item.settings) {
            dispatch(clearRedux("UNIT_BY_STATUS", { [`${idgadget}-items`]: [], [`${idgadget}-total`]: 0 }))
            let values = JSON.parse(item.settings);
            devicesByStatusDashboard({
                ...values,
                offset: 0,
                clear: true
            })
        }
    }, [item])

    useEffect(() => {
        if (update > 0) {
            dispatch(clearRedux("UNIT_BY_STATUS", { [`${idgadget}-items`]: [], [`${idgadget}-total`]: 0 }))
            let values = JSON.parse(item.settings);
            devicesByStatusDashboard({
                ...values,
                offset: 0,
                clear: true
            })
        }
    }, [update])

    const pagingHandler = (value) => {
        let values = JSON.parse(item.settings);
        devicesByStatusDashboard({
            ...values,
            offset: value,
            clear: !value
        })
    }

    useEffect(() => {
        if (exportData) {
            let headers = columns.map((item) => ({ column: item.key, header: item.title, functionString: item.functionString }))
            let query = `
                query searchDevicesByStatus($age: Int!, $unitStatus: [Int]!, $dealerId: Int, $accountId: Int, $manufacturerId: Int, $deviceModelId: Int, $limit: Int, $offset: Int, $tagIds: [Int]) {
                    result: searchDevicesByStatus( age: $age unitStatus: $unitStatus dealerId: $dealerId accountId: $accountId manufacturerId: $manufacturerId deviceModelId: $deviceModelId limit: $limit offset: $offset, tagIds: $tagIds) {
                        items { id accountId accountName esn deviceId eventName lastMessageTime age status manufacturerName, timezone }
                        total
                    }
                }
            `
            let values = JSON.parse(item.settings);
            dispatch(genericExportSend(
                'Csv',
                query,
                {
                    ...values,
                    age: values?.age,
                    unitStatus: values.unitStatus,
                    limit: gadgetInformation[`${idgadget}-total`] || 100,
                    offset: 0,
                    tagIds: values?.tagIds || []
                },
                headers,
                { unit: 'pt', size: 'A4', orientation: 'portrait', fontSize: 12 },
                null,
                null,
                null,
                "Device",
                true
            ));
        }
    }, [exportData])

    return (
        <div className="dashboard-devices-by-status-table">
            <DataView
                columns={columns}
                topheight={430}
                noSplit
                externalLoading={gadgetInformation[`${idgadget}-loading`]}
                externalData={gadgetInformation[`${idgadget}-items`] || []}
                noFilters
                noSearch
                infiniteScroll
                onChangeColumns={(items) => setColumns(items)}
                disableItemSelection
                dataGridExport
                noPDF
                flexEnd
                noRefresh
                noDensity
                noMoreItemsMessage={gadgetInformation[`${idgadget}-items`]?.length ? messages['no_more_items'] : messages['device_status_no_data_message']}
                onChangePage={() => pagingHandler(gadgetInformation[`${idgadget}-items`]?.length || 0)}
                nextToken={typeof gadgetInformation[`${idgadget}-items`] === "undefined" ? true : gadgetInformation[`${idgadget}-items`]?.length < gadgetInformation[`${idgadget}-total`]}
            />
        </div>
    )
}

export default DevicesByStatus